// Названия cookie с данными авторизации.
// Используются и в серверной записи/чтении cookie
// (src/services/Api/server/*, src/services/Api/actions/auth), и в клиентском
// TokenStorage, поэтому вынесены в отдельный модуль.

export const ACCESS_TOKEN_KEY = 'bsAccessToken'
export const REFRESH_TOKEN_KEY = 'bsRefreshToken'
export const TOKEN_EXPIRY_KEY = 'bsTokenExpiry'
